import axios from "axios";
const re = /(?:www.)?(\w+)(\..*)+/;

// Codice agenzia: primo segmento dell'hostname (es. gazmi001.lisaweb.test).
export const agencyCode = () => re.exec(window.location.hostname)[1];

const client = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_URL}`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Max-Age": 28800, // Preflight Caching Using Browser for 8 hours
    [process.env.VUE_APP_GATEWAY]: `${agencyCode()}`,
  },
});

if (process.env.VUE_APP_ENV === 'local') {
  client.defaults.withCredentials = true;
}


export default client;
